import { render } from "./carousel.vue?vue&type=template&id=cda45d10&scoped=true"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"

import "./carousel.vue?vue&type=style&index=0&id=cda45d10&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cda45d10"

export default script